import { useState } from 'react';
import { generateKey, sign, verify } from '../../../engine/didWallet';
import { useCompanyStore } from '../stores/company';

export function Wallet() {
  const company = useCompanyStore((s)=> s.companies.find(c=>c.id===s.activeId) ?? null);
  const [payload, setPayload] = useState('{"hello":"world"}');
  const [sig, setSig] = useState('');
  const gen = async () => { if (company) generateKey(company.id); };
  const doSign = async () => { if (!company) return; const p = JSON.parse(payload); const r = sign(company.id, p); setSig(r.sig); };
  const doVerify = async () => { if (!company) return alert('no company'); const ok = verify(company.id, JSON.parse(payload), sig); alert(ok? 'Valid':'Invalid'); };

  return (
    <div className="space-y-3">
      <div className="font-orbitron text-evat-gold">DID Wallet</div>
      <div className="flex gap-2 text-sm">
        <button onClick={gen} className="px-3 py-1 rounded border border-evat-neon text-evat-neon">Generate Key</button>
        <button onClick={doSign} className="px-3 py-1 rounded border border-evat-gold text-evat-gold">Sign</button>
        <button onClick={doVerify} className="px-3 py-1 rounded border border-evat-neon text-evat-neon">Verify</button>
      </div>
      <textarea value={payload} onChange={(e)=>setPayload(e.target.value)} className="w-full h-32 bg-black border border-neutral-700 rounded p-2 text-xs"/>
      <div className="text-xs break-all text-neutral-400">Sig: {sig || '-'}</div>
    </div>
  );
}

export default Wallet;



















